import { List } from 'immutable';
import { ILocaleLanguage } from '../../constants';

export interface ILocalizationData {
  defaultLanguage: string;
  currentLocale: string;
  supportedLanguages: List<ILocaleLanguage>;
  country: string;
}

export const LOCALIZATION_KEYS: ILocalization = Object.freeze({
  COUNTRY: 'country',
  LANGUAGE: 'language',
  LOCALE: '2goLang',
});

interface ILocalization {
  COUNTRY: string;
  LANGUAGE: string;
  LOCALE: string;
}
